;(function($, undefined){
    'use strict';

    var rnn = window.rnn;

    function checkVersion() {
        /*  we support as low as:
                ios 7.0
                android 4.2
        */

        var ios = parseFloat(rnn.modules.utilities.getIosVersion()),
            android = parseFloat(rnn.modules.utilities.getAndroidVersion());

        if (android < 4.2 || ios < 7) {
            // show not supported alert
            rnn.modules.alert.show($('.mobile-scrolling-nav'), {'message': 'Your device is out of date, and may not be compatible with our website.', 'type': 'info', 'extraClass': 'update-version-alert'});
        }


    }

    function init(){
        if ($('div#flatpage').length) {
            $('div#flatpage img').removeAttr('style');
        }

        checkVersion();
    }

    rnn.modules.register('mobileInit', {
        init: init
    });

})(jQuery);